<div *ngIf="isLobbyLoaded">
    <cc-news-feed-v2-wrapper [containerPath]="containerPath" [trackData]="trackData"></cc-news-feed-v2-wrapper>
</div>
